// WelcomeWhatsNew.jsx
import React, { useState } from 'react';

const AdditionalContent = () => (
  <div className="space-y-6 text-black">
    {/* <p>
      Our goal is to help our patients from infancy, childhood and adolescence reach their full potential as healthy,
      happy and productive adults. We believe that raising a child is a rewarding yet challenging experience for parents
      and guardians, so we partner with families to help them enjoy the process.
    </p> */}
    <p>
      At CIPA, we offer a full range of pediatric care services, including well-child check-ups, same-day sick visits,
      respiratory allergy skin testing, immunizations, ADHD, and functional medicine. We also provide comprehensive
      prenatal visits for expecting parents, alongside newborn care for first-time parents.
    </p>
    <p>
      We know how hectic life can be and are committed to making our practice convenient and accessible for your family.
      Our knowledgeable and caring team is committed to providing quality service in a comfortable, safe office setting
      where children and parents can feel at ease.
    </p>
    <p>
      We strive to provide state-of-the-art care by continuously updating knowledge and technology. Utilizing the latest
      in medical electronic technology we provide a secure web-portal which provides parents convenient access to
      commonly requested information such as vaccination records, appointment and referral requests, prescription refills
      and school/camp forms.
    </p>
    <p>
      We invite you to take a few moments to browse our website and familiarize yourself with our practice. We hope that
      it will serve as a valuable resource for you. You’ll find all the information you need to know about our practice.
    </p>
    <p>For questions or to schedule a visit, contact our office today.</p>
  </div>
);

export default function WelcomeWhatsNew({ updates = [] }) {
  const [showMore, setShowMore] = useState(false);

  return (
    <div className="w-full px-4 mb-8">
      {/* note the added items-start */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-start">

        {/* ——— Card #1: Welcome ——— */}
        <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
          <div className="flex flex-col p-8 space-y-4">
            <h1 className="text-4xl font-bold text-black">
              WELCOME TO OUR PRACTICE
            </h1>
            <hr className="border-t-2 border-gray-400" />

            <p className="text-black">
              Welcome to Central IL Pediatric Associates (CIPA) – an independently-owned,
              Central Illinois-based community pediatric practice.
            </p>
            

            {/* Images */}
            <div className="flex space-x-4">
              <img
                className="rounded-lg shadow-sm flex-shrink-0 w-2/3 object-cover"
                src="https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/CIPAbuilding.webp"
                alt="Our Building"
              />
              <a
                href="https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/Medical_Home_Information_for_Patients.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="w-1/3"
              >
                <img
                  className="rounded-lg w-full h-full object-contain"
                  src="https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/NCQA-PCMH-Certification-Logo.png.webp"
                  alt="NCQA Recognized"
                />
              </a>
            </div>
            <p className='text-black pb-8'>
              Our goal is to help our patients from infancy, childhood and adolescence reach their full potential as healthy,
              happy and productive adults. We believe that raising a child is a rewarding yet challenging experience for parents
              and guardians, so we partner with families to help them enjoy the process.
            </p>
            {showMore && <AdditionalContent />}

            <button
              onClick={() => setShowMore(!showMore)}
              className="text-blue-700 hover:text-blue-900 transition duration-300"
            >
              {showMore ? 'Show Less…' : 'Show More…'}
            </button>
          </div>
        </div>

        {/* ——— Card #2: What’s New ——— */}
        <div className="bg-custom-blue rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
          {/* removed the h-full here */}
          <div className="flex flex-col bg-custom-blue text-white p-8 pb-[70px] space-y-4">
            <h1 className="text-4xl font-bold">What’s New</h1>
            <hr className="border-t-2 border-gray-400" />

            <div className="overflow-auto h-96 p-2 bg-white text-black rounded-lg shadow-inner space-y-4">
              {updates.map((update, idx) => (
                <div
                  key={idx}
                  className="bg-blue-100 p-4 rounded-lg shadow-lg flex items-center space-x-4"
                >
                  <img
                    src="https://w7.pngwing.com/pngs/1017/780/png-transparent-exit-sign-information-fire-safety-exclamation-mark-blue-cdr-angle.png"
                    alt=""
                    className="w-8 h-8 rounded-full object-cover"
                  />
                  <div
                    className="flex-grow"
                    dangerouslySetInnerHTML={{ __html: update }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}
